/**
 * Created by 胡长伟 on 2020-03-07.
 */
import merchtApi from '../../api/servicer';
import rentServcApi from '../../api/rentServc';

function getMerchantAttTagListByAttAspect(attAspect, callback) {
    if(attAspect == null) {
        callback(null);
        return;
    }
    let filter = {attAspect: attAspect};
    merchtApi.getAttTagListByAttAspect(filter, function (result) {
        if(result.type == 'info') {
            callback(result.data);
            //
        } else {
            callback(null);
        }
    });
}
//
let att_tag_list_cache = {};
let att_tag_map_cache = {};
function ComnMerchantAttTag() {
    //---------------------- 获取 -----------------------
    this.getAttTagListByAttAspect = function (filter, callback) {
        let rentFlag = filter.rentFlag;
        if(Utils.isTrue(rentFlag)){
            rentServcApi.getAttTagListByAttAspect(filter, function (result) {
                if(result.type == 'info') {
                    callback(result.data);
                    //
                } else {
                    callback(null);
                }
            });
        }else{
            merchtApi.getAttTagListByAttAspect(filter, function (result) {
                if(result.type == 'info') {
                    callback(result.data);
                    //
                } else {
                    callback(null);
                }
            });
        }

    };
    //
    this.loadAttTagListByAttAspect = function (attAspect, callback, refresh) {
        //from cache
        refresh = refresh == null ? false : refresh;
        if(attAspect == null) {
            callback(null);
            return;
        }
        //
        let attTagList = att_tag_list_cache[attAspect];
        if(refresh) {
            attTagList = null;
        }
        //
        if(attTagList == null) {
            // 数据库获取
            getMerchantAttTagListByAttAspect(attAspect, function (data) {
                attTagList = data || [];
                //
                attTagList.forEach(function (item) {
                    att_tag_map_cache[item.id] = item;
                });
                //
                att_tag_list_cache[attAspect] = attTagList;
                //
                if(typeof callback == 'function') {
                    callback(attTagList);
                } else {
                    console.log(attTagList);
                }
            });
        } else {
            //结果回调
            if(typeof callback == 'function') {
                callback(attTagList);
            } else {
                console.log(attTagList);
            }
        }
    };
    //
    this.loadSelectAttTagByAttAspect = function (attAspect, callback, refresh) {
        if(attAspect == null) {
            callback(null);
            return;
        }
        this.loadAttTagListByAttAspect(attAspect, function (attTagList) {
            let dataList = [];
            //
            if(!Utils.isNoB(attTagList) && attTagList.length > 0) {
                attTagList.forEach(function (item) {
                    dataList.push({
                        value: item.id,
                        label: item.name
                    });
                });
            }
            callback(dataList);
        }, refresh);
    };
    // 显示
    this.getAttTagNameById = function (id, callback) {
        let item = att_tag_map_cache[id];
        if(item == null) {
            if(callback != null && typeof callback == 'function') {
                callback(null);
            }
            return null;
        }
        //
        if(callback != null && typeof callback == 'function') {
            callback(item.name);
        }
        return item.name;
    };
    // 获取业务标签数量
    this.getAttTagCount = function (attAspect, callback, refresh) {
        if(attAspect == null) {
            callback([]);
            return;
        }
        //from cache
        refresh = refresh == null ? false : refresh;
        this.loadAttagListByAttAspect(attAspect, function (attTagList) {
            attTagList = attTagList || [];
            callback(attTagList.length);
        }, refresh);
    };
    // 清除缓存
    this.clearAttTagCache = function (attAspect) {
        //from cache
        att_tag_list_cache[attAspect] = null;
    }
}

//
let comnMerchantAttTag = new ComnMerchantAttTag();

export default comnMerchantAttTag;



//////////////////
// WEBPACK FOOTER
// ./src/compo/conf/ComnAttTag.js
// module id = 1572
// module chunks = 1